import * as React from "react";
import classnames from "classnames";

export interface ISubLegendsProps {
    shown?: boolean;
    expanded?: boolean;
    icons: string[];
    labels?: string[];
}

export const SubIcons = ({ shown, expanded, icons, labels }: ISubLegendsProps): JSX.Element => {
    return (
        <ul
            className={classnames(
                { grayList: !shown },
                "esri-layer-list__list",
                "sublayer",
                { expanded: expanded },
                "esri-layer-list__list--independent"
            )}
        >
            {icons.map((icon, i) => {
                return (
                    <li key={icon + "-icon" + i} className="esri-layer-list__item layerWidgetItem flat">
                        <div className="esri-layer-list__item-container">
                            <div className="layerImageContainer">
                                <img src={icon} />
                            </div>
                            <span className="esri-layer-list__item-title customTitle">{labels[i]}</span>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};
